export const BRAND_NAME = "It's One Number"
export const BRAND_TAGLINE = 'Weekly Video Production Deals'
export const BRAND_DESCRIPTION =
  'Weekly video production reviews with exclusive discounts on the gear we love.'

export const DEFAULT_SITE_TITLE = `${BRAND_NAME} - ${BRAND_TAGLINE}`

export function getPageTitle(pageTitle: string) {
  return `${pageTitle} | ${BRAND_NAME}`
}
